import FacebookAuth from 'js/services/auth-driver/FacebookAuth';

/**
 * Wrapper for Facebook javascript API
 * Based on info from: https://developers.facebook.com/docs/javascript/quickstart
 *
 * @class Facebook
 */
class Facebook {
  /**
   * Perform Facebook API request
   * https://developers.facebook.com/docs/javascript/reference/FB.api/
   *
   * @param {string} path
   * @param {function} method
   * @param {object} params
   * @returns Promise
   * @memberof Facebook
   */
  async api(path, method, params) {
    await FacebookAuth.isInitialized;
    return await new Promise((resolve, reject) => FB.api(path, method, params, response => resolve(response)));
  }

  /**
   * Used for sending messages
   * https://developers.facebook.com/docs/sharing/reference/send-dialog
   *
   * @param {object} options
   */
  async ui(options) {
    await FacebookAuth.isInitialized;
    FB.ui(options);
  }

  /**
   * Post a message on the current users timeline, with optional link
   *
   * @param {string} message The body/text of the post
   * @param {string} [link=null] Optional link to page which will be posted with message on users feed
   * @returns
   * @memberof Facebook
   */
  async postOnTimeline(message, link = null) {
    await FacebookAuth.isInitialized;

    const postData = {
      message: message,
      privacy: {
        value: 'EVERYONE',
      },
    };

    if (link) {
      postData.link = link;
    }

    let apiResponse = null;

    const user = await FacebookAuth.login('email, publish_actions');
    if (user) {
      apiResponse = await this.api('/me/feed', 'post', postData);
    }

    return apiResponse;
  }

  async getUserGroups() {
    const user = await FacebookAuth.login('email, publish_to_groups, user_managed_groups');
    let groupsResponse = null;
    if (user) {
      const { id } = await this.api(`/me/?fields=id`, 'get');
      groupsResponse = await this.api(`/${id}/groups`, 'get');
    }

    return groupsResponse;
  }

  async postOnGroups(group_id) {
    const postData = {
      message: message,
      privacy: {
        value: 'EVERYONE',
      },
    };

    if (link) {
      postData.link = link;
    }

    let apiResponse = null;

    const user = await FacebookAuth.login('email, publish_actions, publish_to_groups');
    if (user) {
      apiResponse = await this.api('/' + group_id + '/feed', 'post', postData);
    }

    return apiResponse;
  }
}

export default new Facebook();
